__webpack_require__.p = "/reports-update-echarts/referrals-hub/";